import { NotificationManager } from "react-notifications";

class StorageManager {
  static instance;

  constructor() {
    if (StorageManager.instance) {
      return StorageManager.instance;
    }

    this.inMemoryStorage = {};
    this.useInMemoryStorage = false;

    for (let key of Object.keys(localStorage)) {
      this.inMemoryStorage[key] = localStorage.getItem(key);
    }

    StorageManager.instance = this;
  }

  setItem(key, value) {
    if (!this.useInMemoryStorage) {
      try {
        this.inMemoryStorage[key] = value;
        localStorage.setItem(key, value);
      } catch (e) {
        if (e instanceof DOMException && e.name === "QuotaExceededError") {
          this.useInMemoryStorage = true;
          NotificationManager.warning(
            "Storage quota exceeded. You may lose your work if you close the browser before saving."
          );
        } else {
          NotificationManager.warning("Something went wrong saving local data.");
        }
      }
    } else {
      this.inMemoryStorage[key] = value;
    }
  }

  getItem(key) {
    if (this.useInMemoryStorage) {
      return this.inMemoryStorage[key];
    } else {
      return localStorage.getItem(key);
    }
  }

  removeItem(key) {
    delete this.inMemoryStorage[key];
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.warn(`Error removing ${key} from localStorage.`, e);
    }
  }

  keys() {
    if (this.useInMemoryStorage) {
      return Object.keys(this.inMemoryStorage);
    } else {
      return Object.keys(localStorage);
    }
  }

  clear() {
    this.inMemoryStorage = {};
    this.useInMemoryStorage = false;
    localStorage.clear();
  }
}

const storageManager = new StorageManager();
window.storageManager = storageManager;
export default storageManager;
